import cx from 'classix';

const Divider = ({ className }: { className?: string }) => {
  return (
    <div>
      <hr className={cx('bg-accent-500 h-0.5 w-24 sm:w-48 my-4', className)} />
    </div>
  );
};

export default Divider;
